module.exports = __webpack_public_path__ + "static/media/icons.faff9214.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/semantic/themes/default/assets/fonts/icons.woff
// module id = 4405
// module chunks = 0